/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(14);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var grad_1 = __webpack_require__(2);
	var color_1 = __webpack_require__(4);
	var fractalbuilder_1 = __webpack_require__(7);
	var juliabuilder_1 = __webpack_require__(12);
	var point_1 = __webpack_require__(9);
	var tutorial_1 = __webpack_require__(13);
	var canvasm = document.getElementById("canvasm"), canvasj = document.getElementById("canvasj"), initialpixelratio = 0.008;
	var mandelbrot, julia, windowwidth = $(window).width(), windowheight = $(window).height(), tutorial = new tutorial_1.Tutorial('.tutorial-message');
	function init() {
	    var values = new Array();
	    values.push(new grad_1.GradData(0, new color_1.Color(0, 0, 0)));
	    values.push(new grad_1.GradData(99, new color_1.Color(255, 255, 255)));
	    var data = new grad_1.GradOptions(values, sliderclick, repaintgradient);
	    $.fn.grad = grad_1.GradPlugin;
	    $('.gradslider').grad(data);
	    $('.colorpicker').minicolors({
	        inline: true,
	        changeDelay: 200,
	        change: function (value, opacity) {
	            var color = new color_1.Color();
	            color.parsehex(value);
	            $('.gradslider').grad().setcolor(color);
	            repaintgradient($('.gradslider').grad().getgradient());
	        }
	    });
	    tutorial.setlevel(1);
	    initevents();
	    initfractals(values);
	}
	function sliderclick(el, data) {
	    $('.colorpicker').minicolors('value', data.color.tohex());
	}
	function repaintgradient(gradient) {
	    mandelbrot.setgradient(gradient);
	    mandelbrot.redraw(false);
	    julia.setgradient(gradient);
	    julia.redraw(false);
	}
	function initfractals(gradient) {
	    canvasm.width = canvasj.width = $(window).width();
	    canvasm.height = canvasj.height = $(window).height();
	    mandelbrot = new fractalbuilder_1.FractalBuilder('mandelbrot');
	    julia = new juliabuilder_1.JuliaBuilder('julia');
	    mandelbrot.setcanvas(canvasm);
	    julia.setcanvas(canvasj);
	    mandelbrot.beforeevent = function () { return $('.label-mandel').addClass('loading'); };
	    mandelbrot.afterevent = function () { return $('.label-mandel').removeClass('loading'); };
	    julia.beforeevent = function () { return $('.label-julia').addClass('loading'); };
	    julia.afterevent = function () { return $('.label-julia').removeClass('loading'); };
	    mandelbrot.setgradient(gradient);
	    julia.setgradient(gradient);
	    mandelbrot.redraw();
	    julia.redraw();
	    mandelbrot.onzoomin = function () { tutorial.setlevel(2); };
	    mandelbrot.onzoomout = function () { tutorial.setlevel(3); };
	    mandelbrot.ondrag = function () { tutorial.setlevel(4); };
	    mandelbrot.onclick = mouseclick;
	    julia.onzoomin = function () { tutorial.setlevel(2); };
	    julia.onzoomout = function () { tutorial.setlevel(3); };
	    julia.ondrag = function () { tutorial.setlevel(4); };
	}
	function mouseclick(e) {
	    julia.jconstant = e;
	    julia.center = new point_1.Point(0, 0);
	    julia.pixelratio = initialpixelratio;
	    julia.redraw();
	    tutorial.setlevel(5);
	}
	function initevents() {
	    var inputss = document.getElementsByName("supersampling");
	    var inputtype = document.getElementsByName("type");
	    var reset = document.getElementById("reset");
	    var form = document.getElementById("mainform");
	    var addcolors = document.getElementById("addcolor");
	    var deletecolors = document.getElementById("deletecolor");
	    var save = document.getElementById("save");
	    var fractalradio = document.getElementsByName("fakecheck");
	    var configbutton = document.getElementById("menu-toggle");
	    var zoomin = document.getElementById('zoomin');
	    var zoomout = document.getElementById('zoomout');
	    form.addEventListener("submit", onsubmit, false);
	    reset.addEventListener("click", onreset, false);
	    addcolors.addEventListener("click", addcolor, false);
	    deletecolors.addEventListener("click", deletecolor, false);
	    save.addEventListener("click", saveclick, false);
	    configbutton.addEventListener("click", function () { tutorial.setlevel(7); }, false);
	    zoomin.addEventListener("click", zoomincurrent, false);
	    zoomout.addEventListener("click", zoomoutcurrent, false);
	    for (var i = 0; i < inputss.length; i++) {
	        inputss[i].addEventListener("change", onsubmit, false);
	    }
	    for (var i = 0; i < inputtype.length; i++) {
	        inputtype[i].addEventListener("change", function () {
	            julia.center = mandelbrot.center = new point_1.Point(0, 0);
	            julia.pixelratio = mandelbrot.pixelratio = initialpixelratio;
	            onsubmit(null);
	        }, false);
	    }
	    for (var i = 0; i < fractalradio.length; i++) {
	        fractalradio[i].addEventListener("change", function () { tutorial.setlevel(6); }, false);
	    }
	    setInterval(function () {
	        var currentw = $(window).width();
	        var currenth = $(window).height();
	        if (currentw != windowwidth || currenth != windowheight) {
	            onresizewindow();
	        }
	    }, 300);
	}
	function zoomincurrent() {
	    var mandel = document.getElementById('radiomandel');
	    if (mandel.checked)
	        mandelbrot.zoomin(null);
	    else
	        julia.zoomin(null);
	}
	function zoomoutcurrent() {
	    var mandel = document.getElementById('radiomandel');
	    if (mandel.checked)
	        mandelbrot.zoomout();
	    else
	        julia.zoomout();
	}
	function saveclick() {
	    var canvas = $('.fakecheck:checked + label canvas')[0];
	    var image = canvas.toDataURL("image/png");
	    image = image.replace(/^data:image\/[^;]*/, 'data:application/octet-stream');
	    image = image.replace(/^data:application\/octet-stream/, 'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=Canvas.png');
	    this.href = image;
	}
	function addcolor() {
	    $('.gradslider').grad().addcolor(new color_1.Color(255, 255, 255));
	    var gradient = $('.gradslider').grad().getgradient();
	    repaintgradient(gradient);
	}
	function deletecolor() {
	    var index = $('.gradslider .handle.selected').index();
	    $('.gradslider .handle.selected').remove();
	    $('.gradslider').grad().deletecolor(index);
	    var gradient = $('.gradslider').grad().getgradient();
	    repaintgradient(gradient);
	}
	function onresizewindow() {
	    windowwidth = $(window).width();
	    windowheight = $(window).height();
	    canvasm.width = canvasj.width = windowwidth;
	    canvasm.height = canvasj.height = windowheight;
	    mandelbrot.redraw();
	    julia.redraw();
	}
	function onsubmit(e) {
	    var inputs = document.getElementById("in_steps");
	    var inputss = document.getElementsByName("supersampling");
	    var inputtype = document.getElementsByName("type");
	    mandelbrot.steps = parseInt(inputs.value, 10);
	    julia.steps = parseInt(inputs.value, 10);
	    for (var i = 0; i < inputss.length; i++) {
	        if (inputss[i].checked) {
	            mandelbrot.supersampling = parseInt(inputss[i].value, 10);
	            julia.supersampling = parseInt(inputss[i].value, 10);
	        }
	    }
	    for (var i = 0; i < inputtype.length; i++) {
	        if (inputtype[i].checked) {
	            mandelbrot.type = inputtype[i].value == "mandelbrot" ? "mandelbrot" : "ship";
	            julia.type = inputtype[i].value == "mandelbrot" ? "julia" : "juliaship";
	        }
	    }
	    var gradient = $('.gradslider').grad().getgradient();
	    mandelbrot.setgradient(gradient);
	    julia.setgradient(gradient);
	    mandelbrot.redraw();
	    julia.redraw();
	    e.preventDefault();
	}
	function onreset(e) {
	    julia.center = mandelbrot.center = new point_1.Point(0, 0);
	    julia.pixelratio = mandelbrot.pixelratio = initialpixelratio;
	    mandelbrot.redraw();
	    julia.redraw();
	}
	init();


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var graddata_1 = __webpack_require__(3);
	exports.GradData = graddata_1.GradData;
	var gradoptions_1 = __webpack_require__(5);
	exports.GradOptions = gradoptions_1.GradOptions;
	var gradbody_1 = __webpack_require__(6);
	exports.GradBody = gradbody_1.GradBody;
	function GradPlugin(initialvalues) {
	    var instance = this;
	    var body = instance.data('gradbw');
	    if (body == null) {
	        body = new gradbody_1.GradBody(instance, initialvalues);
	        instance.data('gradbw', body);
	    }
	    return body;
	}
	exports.GradPlugin = GradPlugin;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var color_1 = __webpack_require__(4);
	exports.Color = color_1.Color;
	var GradData = (function () {
	    function GradData(value, color) {
	        if (color === void 0) { color = new color_1.Color(); }
	        this.value = value;
	        this.color = color;
	    }
	    return GradData;
	}());
	exports.GradData = GradData;


/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	var Color = (function () {
	    function Color(r, g, b) {
	        if (r === void 0) { r = 0; }
	        if (g === void 0) { g = 0; }
	        if (b === void 0) { b = 0; }
	        this.r = r;
	        this.g = g;
	        this.b = b;
	    }
	    Color.prototype.tohex = function () {
	        var r = this.r.toString(16);
	        r = r.length < 2 ? '0' + r : r;
	        var g = this.g.toString(16);
	        g = g.length < 2 ? '0' + g : g;
	        var b = this.b.toString(16);
	        b = b.length < 2 ? '0' + b : b;
	        return "#" + r + g + b;
	    };
	    Color.prototype.torgb = function () {
	        return "rgb(" + this.r + "," + this.g + "," + this.b + ")";
	    };
	    Color.prototype.parsehex = function (hex) {
	        var r = hex.substr(1, 2);
	        var g = hex.substr(3, 2);
	        var b = hex.substr(5, 2);
	        this.r = parseInt(r, 16);
	        this.g = parseInt(g, 16);
	        this.b = parseInt(b, 16);
	    };
	    return Color;
	}());
	exports.Color = Color;


/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	var GradOptions = (function () {
	    function GradOptions(values, sliderclick, setgradient) {
	        if (sliderclick === void 0) { sliderclick = function () { }; }
	        if (setgradient === void 0) { setgradient = function () { }; }
	        this.values = values;
	        this.sliderclick = sliderclick;
	        this.setgradient = setgradient;
	    }
	    return GradOptions;
	}());
	exports.GradOptions = GradOptions;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var graddata_1 = __webpack_require__(3);
	var color_1 = __webpack_require__(4);
	var GradBody = (function () {
	    function GradBody(instance, options) {
	        this.datalabel = "graddata";
	        this.instance = instance;
	        this.sliderclick = options.sliderclick;
	        this.setgradient = options.setgradient;
	        this.values = options.values ||
	            [
	                new graddata_1.GradData(0),
	                new graddata_1.GradData(100, new color_1.Color(255, 255, 255))
	            ];
	        this.render();
	        this.updatehandlespositions();
	        this.instance.find('.handle').first().addClass('selected');
	    }
	    GradBody.prototype.getgradient = function () {
	        return _.orderBy(this.values, ['value', 'asc']);
	    };
	    GradBody.prototype.renderhtml = function () {
	        var _this = this;
	        _this.instance.addClass('bwslider');
	        var handles = _this.instance.find('.handle');
	        while (handles.length < _this.values.length) {
	            _this.instance.append($('<span>')
	                .addClass('handle')
	                .draggable({
	                containment: 'parent',
	                axis: 'x',
	                drag: function () {
	                    _this.instance.find('.handle').removeClass('selected');
	                    $(this).addClass('selected');
	                    _this.updatevalues();
	                    _this.updatehandlesstyles();
	                    _this.updatecontrolgradient();
	                },
	                stop: function () {
	                    _this.instance.find('.handle').removeClass('selected');
	                    $(this).addClass('selected');
	                    _this.updatevalues();
	                    _this.updatehandlesstyles();
	                    _this.updatecontrolgradient();
	                    _this.setgradient(_this.values);
	                }
	            })
	                .click(function () {
	                _this.instance.find('.handle').removeClass('selected');
	                $(this).addClass('selected');
	                _this.sliderclick(this, $(this).data(_this.datalabel));
	            }));
	            handles = _this.instance.find('.handle');
	        }
	    };
	    GradBody.prototype.sethandledata = function () {
	        var _this = this;
	        _this.instance.find('.handle').each(function (i) {
	            $(this).data(_this.datalabel, _this.values[i]);
	        });
	    };
	    GradBody.prototype.updatehandlesstyles = function () {
	        var _this = this;
	        _this.instance.find('.handle').each(function () {
	            var data = $(this).data(_this.datalabel);
	            $(this).css({
	                background: data.color.tohex()
	            });
	        });
	    };
	    GradBody.prototype.updatehandlespositions = function () {
	        var _this = this;
	        _this.instance.find('.handle').each(function () {
	            var data = $(this).data(_this.datalabel);
	            $(this).css({
	                left: data.value + "%"
	            });
	        });
	    };
	    GradBody.prototype.updatecontrolgradient = function () {
	        var _this = this;
	        var css = "";
	        var values = _.orderBy(_this.values, ['value', 'asc']);
	        for (var i = 0; i < values.length; i++) {
	            css += ", " + values[i].color.tohex() + " " + values[i].value + "%";
	        }
	        _this.instance.css("background-image", "-webkit-linear-gradient(left " + css + ")");
	        _this.instance.css("background-image", "-moz-linear-gradient(to right " + css + ")");
	        _this.instance.css("background-image", "-o-linear-gradient(left " + css + ")");
	        _this.instance.css("background-image", "linear-gradient(left " + css + ")");
	    };
	    GradBody.prototype.render = function () {
	        var _this = this;
	        _this.instance.addClass('bwslider');
	        _this.renderhtml();
	        _this.sethandledata();
	        _this.updatehandlesstyles();
	        _this.updatecontrolgradient();
	    };
	    GradBody.prototype.updatevalues = function () {
	        var _this = this;
	        _this.instance.find('.handle').each(function (i) {
	            var data = $(this).data(_this.datalabel);
	            data.value = Math.floor($(this).position().left / _this.instance.width() * 100.0);
	            $(this).data(_this.datalabel, data);
	            _this.values[i] = data;
	        });
	    };
	    GradBody.prototype.addcolor = function (color) {
	        var _this = this;
	        _this.values.push(new graddata_1.GradData(50, color));
	        _this.render();
	        _this.updatehandlespositions();
	        _this.instance.find('.handle').removeClass('selected');
	        _this.instance.find('.handle').last().addClass('selected');
	    };
	    GradBody.prototype.setcolor = function (color) {
	        var _this = this;
	        var handle = _this.instance.find('.handle.selected');
	        if (handle.length > 0) {
	            var data = handle.data(_this.datalabel);
	            if (data != null) {
	                data.color = color;
	                handle.data(_this.datalabel, data);
	                _this.updatevalues();
	                _this.updatehandlesstyles();
	                _this.updatecontrolgradient();
	            }
	        }
	    };
	    GradBody.prototype.deletecolor = function (index) {
	        var _this = this;
	        _this.values = _.remove(this.values, function (val, i) { return i != index; });
	        _this.render();
	    };
	    GradBody.prototype.click = function (callback) {
	        var _this = this;
	        _this.sliderclick = callback;
	    };
	    return GradBody;
	}());
	exports.GradBody = GradBody;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Utils = __webpack_require__(8);
	var responsedata_1 = __webpack_require__(10);
	var point_1 = __webpack_require__(9);
	var colorcomputer_1 = __webpack_require__(11);
	var FractalBuilder = (function () {
	    function FractalBuilder(type) {
	        this.type = type;
	        this.center = new point_1.Point(0, 0);
	        this.steps = 80;
	        this.pixelratio = 0.008;
	        this.supersampling = 1;
	        this.hammerevents = function (e, instance) {
	            console.log("type: " + e.type + ", point: " + e.center.x + " " + e.center.y + ", delta: " + e.deltaX + " " + e.deltaY);
	            var center = Utils.getcoordsfrompoint(e.center, instance.canvas, instance.pixelratio, instance.center);
	            switch (e.type) {
	                case 'tap':
	                    instance.onclick(center);
	                    break;
	                case 'pinchend':
	                    e.scale > 1 ? instance.zoomin(center) : instance.zoomout();
	                    break;
	                case 'panend':
	                    instance.drag(new point_1.Point(-e.deltaX * instance.pixelratio, -e.deltaY * instance.pixelratio));
	                    break;
	            }
	        };
	        this.handleEvent = function (e) {
	            var mevent = e;
	            var wevent = e;
	            var instance = this;
	            var coords = Utils.getcoords(mevent, instance.canvas, instance.pixelratio, instance.center);
	            if (instance.ready) {
	                switch (e.type) {
	                    case 'mousewheel':
	                        if (wevent.deltaY > 0)
	                            instance.zoomout();
	                        else
	                            instance.zoomin(coords);
	                        break;
	                    case 'DOMMouseScroll':
	                        if (wevent.detail > 0)
	                            instance.zoomout();
	                        else
	                            instance.zoomin(coords);
	                        break;
	                }
	                wevent.preventDefault();
	            }
	        };
	        var instance = this;
	        instance.ready = true;
	        instance.dataparts = new Array();
	        instance.threadsnumber = navigator.hardwareConcurrency;
	        if (typeof (instance.threadsnumber) == "undefined")
	            instance.threadsnumber = 4;
	        instance.workers = [];
	        var _loop_1 = function(i) {
	            instance.workers.push(new Worker("./scripts/worker.bundle.js"));
	            instance.workers[i].onmessage = function (e) {
	                var data = new responsedata_1.ResponseData();
	                data.data = new Uint32Array(e.data);
	                data.threadid = i;
	                instance.dataparts.push(data);
	                instance.checkready();
	            };
	        };
	        for (var i = 0; i < instance.threadsnumber; i++) {
	            _loop_1(i);
	        }
	    }
	    FractalBuilder.prototype.setcanvas = function (canvas) {
	        var instance = this;
	        instance.canvas = canvas;
	        var mc = new Hammer(canvas);
	        mc.get('pan').set({ direction: Hammer.DIRECTION_ALL });
	        mc.get('pinch').set({ enable: true });
	        mc.on("pinchend tap panend", function (e) { instance.hammerevents(e, instance); });
	        instance.canvas.addEventListener("mousewheel", instance, false);
	        instance.canvas.addEventListener("DOMMouseScroll", instance, false);
	    };
	    FractalBuilder.prototype.zoomin = function (coords) {
	        if (coords != null)
	            this.center = coords;
	        this.pixelratio *= 0.5;
	        this.redraw(true);
	        this.onzoomin();
	    };
	    FractalBuilder.prototype.zoomout = function () {
	        if (this.pixelratio * 2 <= 0.008) {
	            this.pixelratio *= 2;
	            this.redraw(true);
	            this.onzoomout();
	        }
	    };
	    FractalBuilder.prototype.drag = function (change) {
	        this.center.x += change.x;
	        this.center.y -= change.y;
	        this.redraw(true);
	        this.ondrag();
	    };
	    FractalBuilder.prototype.generate = function () {
	        var _this = this;
	        _this.timer = (new Date()).getTime();
	        _this.ready = false;
	        var height = Math.floor(_this.canvas.height / _this.threadsnumber);
	        var postdata = {
	            type: _this.type,
	            width: _this.canvas.width,
	            height: height,
	            steps: _this.steps,
	            pixelratio: _this.pixelratio,
	            x: _this.center.x,
	            y: -_this.center.y - (_this.pixelratio * height) * (_this.threadsnumber / 2.0 - 0.5),
	            supersampling: _this.supersampling
	        };
	        for (var i = 0; i < _this.threadsnumber; i++) {
	            _this.workers[i].postMessage(postdata);
	            postdata.y += (_this.pixelratio * height);
	        }
	    };
	    FractalBuilder.prototype.checkready = function () {
	        if (this.dataparts.length == this.threadsnumber) {
	            this.data = _.chain(this.dataparts).sortBy("threadid").map(function (n) { return n.data; }).value();
	            this.repaint();
	            this.dataparts = new Array();
	            this.ready = true;
	        }
	    };
	    FractalBuilder.prototype.redraw = function (regenerate) {
	        if (regenerate === void 0) { regenerate = true; }
	        if (this.ready) {
	            if (this.beforeevent != null) {
	                this.beforeevent();
	            }
	            if (regenerate) {
	                this.generate();
	            }
	            else {
	                this.repaint();
	            }
	        }
	    };
	    FractalBuilder.prototype.repaint = function () {
	        var cx = this.canvas.getContext("2d");
	        var width = this.canvas.width;
	        var height = this.canvas.height;
	        var pxdata = cx.createImageData(width, height);
	        var datapos = 0;
	        for (var i = 0; i < this.data.length; i++) {
	            for (var j = 0; j < this.data[i].length; j++) {
	                pxdata.data[datapos++] = this.redcolorchanel[this.data[i][j]];
	                pxdata.data[datapos++] = this.greencolorchanel[this.data[i][j]];
	                pxdata.data[datapos++] = this.bluecolorchanel[this.data[i][j]];
	                pxdata.data[datapos++] = 255;
	            }
	        }
	        cx.putImageData(pxdata, 0, 0);
	        if (this.afterevent != null) {
	            this.afterevent();
	        }
	    };
	    FractalBuilder.prototype.setgradient = function (gradient) {
	        this.redcolorchanel = new Int16Array(this.steps + 1);
	        this.greencolorchanel = new Int16Array(this.steps + 1);
	        this.bluecolorchanel = new Int16Array(this.steps + 1);
	        var comp = new colorcomputer_1.ColorComputer(gradient);
	        for (var i = 0; i <= this.steps; i++) {
	            var color = comp.getcolor(this.steps, i);
	            this.redcolorchanel[i] = color.r;
	            this.greencolorchanel[i] = color.g;
	            this.bluecolorchanel[i] = color.b;
	        }
	    };
	    return FractalBuilder;
	}());
	exports.FractalBuilder = FractalBuilder;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var point_1 = __webpack_require__(9);
	function scaleto(lv, scale, max) {
	    return lv / max * scale;
	}
	exports.scaleto = scaleto;
	function getclickposition(canvas, e) {
	    var rect = canvas.getBoundingClientRect(), // abs. size of element
	    scaleX = canvas.width / rect.width, // relationship bitmap vs. element for X
	    scaleY = canvas.height / rect.height; // relationship bitmap vs. element for Y
	    var pos = {
	        x: (e.clientX - rect.left) * scaleX,
	        y: (e.clientY - rect.top) * scaleY // been adjusted to be relative to element
	    };
	    return pos;
	}
	exports.getclickposition = getclickposition;
	function getcoords(e, canvas, pxratio, base) {
	    var pos = getclickposition(canvas, e);
	    return new point_1.Point((pos.x - canvas.width / 2) * pxratio + base.x, (canvas.height / 2 - pos.y) * pxratio + base.y);
	}
	exports.getcoords = getcoords;
	function getcoordsfrompoint(center, canvas, pxratio, base) {
	    return new point_1.Point((center.x - canvas.width / 2) * pxratio + base.x, (canvas.height / 2 - center.y) * pxratio + base.y);
	}
	exports.getcoordsfrompoint = getcoordsfrompoint;


/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	var Point = (function () {
	    function Point(x, y) {
	        this.x = x;
	        this.y = y;
	    }
	    return Point;
	}());
	exports.Point = Point;


/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	var ResponseData = (function () {
	    function ResponseData() {
	    }
	    return ResponseData;
	}());
	exports.ResponseData = ResponseData;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var graddata_1 = __webpack_require__(3);
	var color_1 = __webpack_require__(4);
	var ColorComputer = (function () {
	    function ColorComputer(gradient) {
	        gradient = _.orderBy(gradient, ['value']);
	        if (gradient[0].value > 0) {
	            var head = new Array();
	            head.push(new graddata_1.GradData(0, gradient[0].color));
	            gradient = head.concat(gradient);
	        }
	        if (gradient[gradient.length - 1].value < 100) {
	            var tail = new Array();
	            tail.push(new graddata_1.GradData(100, gradient[gradient.length - 1].color));
	            gradient = gradient.concat(tail);
	        }
	        gradient = _.chain(gradient)
	            .groupBy('value')
	            .map(function (el) {
	            return el[0];
	        })
	            .value();
	        this.gradient = gradient;
	    }
	    ColorComputer.prototype.getcolor = function (max, val) {
	        var x = val / max * 100;
	        var edges = this.getedges(x);
	        var diffvalue = edges[0].value - edges[1].value;
	        var addvalue = edges[0].value + edges[1].value;
	        var ar = (edges[0].color.r - edges[1].color.r) / diffvalue;
	        var br = (edges[0].color.r + edges[1].color.r - ar * addvalue) / 2.0;
	        var funR = function (x) { return x * ar + br; };
	        var ag = (edges[0].color.g - edges[1].color.g) / diffvalue;
	        var bg = (edges[0].color.g + edges[1].color.g - ag * addvalue) / 2.0;
	        var funG = function (x) { return x * ag + bg; };
	        var ab = (edges[0].color.b - edges[1].color.b) / diffvalue;
	        var bb = (edges[0].color.b + edges[1].color.b - ab * addvalue) / 2.0;
	        var funB = function (x) { return x * ab + bb; };
	        return new color_1.Color(funR(val), funG(val), funB(val));
	    };
	    ColorComputer.prototype.getedges = function (val) {
	        if (val == 100) {
	            return [
	                this.gradient[this.gradient.length - 2],
	                this.gradient[this.gradient.length - 1]
	            ];
	        }
	        return [
	            _.findLast(this.gradient, function (el) { return el.value <= val; }),
	            _.find(this.gradient, function (el) { return el.value > val; })
	        ];
	    };
	    return ColorComputer;
	}());
	exports.ColorComputer = ColorComputer;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var fractalbuilder_1 = __webpack_require__(7);
	var point_1 = __webpack_require__(9);
	var JuliaBuilder = (function (_super) {
	    __extends(JuliaBuilder, _super);
	    function JuliaBuilder(type) {
	        _super.call(this, type);
	        this.jconstant = new point_1.Point(0.12, 0.63);
	    }
	    JuliaBuilder.prototype.generate = function () {
	        var _this = this;
	        _this.timer = (new Date()).getTime();
	        _this.ready = false;
	        var height = Math.floor(_this.canvas.height / _this.threadsnumber);
	        var postdata = {
	            type: _this.type,
	            width: _this.canvas.width,
	            height: height,
	            steps: _this.steps,
	            pixelratio: _this.pixelratio,
	            x: _this.center.x,
	            y: -_this.center.y - (_this.pixelratio * height) * (_this.threadsnumber / 2.0 - 0.5),
	            supersampling: _this.supersampling,
	            cx: _this.jconstant.x,
	            cy: -_this.jconstant.y
	        };
	        for (var i = 0; i < _this.threadsnumber; i++) {
	            _this.workers[i].postMessage(postdata);
	            postdata.y += (_this.pixelratio * height);
	        }
	    };
	    return JuliaBuilder;
	}(fractalbuilder_1.FractalBuilder));
	exports.JuliaBuilder = JuliaBuilder;


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	var Tutorial = (function () {
	    function Tutorial(selector) {
	        this.selector = selector;
	        this.storagekey = 'tutorial';
	        this.classmessage = '.message';
	        this.showcurrent = function () {
	            $("" + this.selector).hide();
	            $(this.selector + " + .tooltip").hide();
	            $("" + this.selector + this.classmessage + this.getlevel()).show();
	            $("" + this.selector + this.classmessage + this.getlevel() + " + .tooltip").show();
	        };
	        this.setlevel = function (nextlevel) {
	            var level = this.getlevel();
	            if (level + 1 == nextlevel) {
	                localStorage.setItem(this.storagekey, nextlevel.toString());
	            }
	            this.showcurrent();
	        };
	        this.getlevel = function () {
	            var level = parseInt(localStorage.getItem(this.storagekey), 10);
	            if (isNaN(level)) {
	                return 0;
	            }
	            return level;
	        };
	        $("" + this.selector).tooltip({ trigger: 'manual' });
	        $("" + this.selector).tooltip('show');
	        $("" + this.selector).hide();
	        $(this.selector + " + .tooltip").hide();
	    }
	    return Tutorial;
	}());
	exports.Tutorial = Tutorial;


/***/ },
/* 14 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** scripts/app.bundle.js
 **/